
export const ALERT_LIVE_NOT_SUPPORT_TRANSLATE = '번역을 지원하지 않는 채널입니다.';
export const ALERT_LIVE_NOT_SUPPORT_CHATTING = '플레이톡을 지원하지 않는 채널입니다.';
export const ALERT_LIVE_MAXUSER_CHATTING = '플레이톡은 접속 폭주로 인해 선착순 입장제한이 있습니다. 다음에 참여 부탁드립니다.';
